import * as React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import SolidCheckCircleIcon from 'LuxKit/Icons/solid/SolidCheckCircleIcon'
import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'

const Legend = styled.div`
  display: flex;
  gap: ${rem(8)};
`

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
`

interface Props {
  duration?: number
}

function CalendarAvailabilityLegend({ duration }: Props) {
  const intl = useIntl()

  return (
    <Legend>
      <LegendItem>
        <SolidCheckCircleIcon colour="highlight-primary-dark" size="XS" />
        <BodyText variant="medium" colour="light-foreground-alt">
          {intl.formatMessage(
            {
              id: 'hhk5ubzDdO2ECLN_Xl_B',
              defaultMessage: 'Available for {count, plural, one {# night} other {# nights}}',
              description: 'Legend label for available dates in the alternative dates calendar',
            },
            { count: duration ?? 1 },
          )}
        </BodyText>
      </LegendItem>
      <LegendItem>
        <LineSearchIcon colour="light-foreground-alt" size="XS" />
        <BodyText variant="medium" colour="light-foreground-alt">
          {intl.formatMessage({
            id: 'lRSAYdaYD0aVkdUSoR7n',
            defaultMessage: 'Search dates',
            description: 'Legend label for search dates in the alternative dates calendar',
          })}
        </BodyText>
      </LegendItem>
    </Legend>
  )
}

export default React.memo(CalendarAvailabilityLegend)
